<ng-template #renderItemTemplate let-type let-page="page">
  <a class="ant-pagination-item-link" *ngIf="type!='page'"></a>
  <a *ngIf="type=='page'">{{page}}</a>
</ng-template>
<ng-container *ngIf="(dwHideOnSinglePage&&(dwTotal>dwPageSize))||!dwHideOnSinglePage">
  <ul
    *ngIf="dwSimple"
    [class.ant-table-pagination]="dwInTable"
    class="ant-pagination ant-pagination-simple">
    <li
      title="{{ locale.prev_page }}"
      class="ant-pagination-prev"
      (click)="jumpPreOne()"
      [class.ant-pagination-disabled]="isFirstIndex">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'pre'}"></ng-template>
    </li>
    <li [attr.title]="dwPageIndex+'/'+lastIndex" class="ant-pagination-simple-pager">
      <input
        #simplePagerInput
        [ngModel]="dwPageIndex"
        (keydown.enter)="handleKeyDown($event,simplePagerInput,false)"
        size="3">
      <span class="ant-pagination-slash">／</span>
      {{ lastIndex }}
    </li>
    <li
      title="{{ locale.next_page }}"
      class="ant-pagination-next"
      (click)="jumpNextOne()"
      [class.ant-pagination-disabled]="isLastIndex">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'next'}"></ng-template>
    </li>
  </ul>
  <ul
    *ngIf="!dwSimple"
    [class.mini]="dwSize=='small'"
    [class.ant-table-pagination]="dwInTable"
    class="ant-pagination">
      <span class="ant-pagination-total-text" *ngIf="dwShowTotal">
        <ng-template
          [ngTemplateOutlet]="dwShowTotal"
          [ngTemplateOutletContext]="{ $implicit: dwTotal,range:[(dwPageIndex-1)*dwPageSize+1, min(dwPageIndex*dwPageSize, dwTotal)] }">
        </ng-template>
      </span>
    <li
      title="{{ locale.prev_page }}"
      class="ant-pagination-prev"
      (click)="jumpPreOne()"
      [class.ant-pagination-disabled]="isFirstIndex">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'pre'}"></ng-template>
    </li>
    <li
      [attr.title]="firstIndex"
      class="ant-pagination-item"
      (click)="jumpPage(firstIndex)"
      [class.ant-pagination-item-active]="isFirstIndex">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'page',page: firstIndex }"></ng-template>
    </li>
    <li
      [attr.title]="locale.prev_5"
      (click)="jumpPreFive()"
      class="ant-pagination-jump-prev"
      *ngIf="(lastIndex >9)&&(dwPageIndex-3>firstIndex)">
      <a></a>
    </li>
    <li
      *ngFor="let page of pages"
      [attr.title]="page.index"
      class="ant-pagination-item"
      (click)="jumpPage(page.index)"
      [class.ant-pagination-item-active]="dwPageIndex==page.index">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'page',page: page.index }"></ng-template>
    </li>
    <li
      [attr.title]="locale.next_5"
      (click)="jumpNextFive()"
      class="ant-pagination-jump-next"
      *ngIf="(lastIndex >9)&&(dwPageIndex+3<lastIndex)">
      <a></a>
    </li>
    <li
      [attr.title]="lastIndex"
      class="ant-pagination-item"
      (click)="jumpPage(lastIndex)"
      *ngIf="(lastIndex>0)&&(lastIndex!==firstIndex)"
      [class.ant-pagination-item-active]="isLastIndex">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'page',page: lastIndex }"></ng-template>
    </li>
    <li
      title="{{ locale.next_page }}"
      class="ant-pagination-next"
      (click)="jumpNextOne()"
      [class.ant-pagination-disabled]="isLastIndex">
      <ng-template [ngTemplateOutlet]="dwItemRender" [ngTemplateOutletContext]="{ $implicit: 'next'}"></ng-template>
    </li>
    <div class="ant-pagination-options" *ngIf="dwShowQuickJumper||dwShowSizeChanger">
      <dw-select
        *ngIf="dwShowSizeChanger"
        [dwSize]="dwSize=='small'?'small':''"
        class="ant-pagination-options-size-changer"
        [ngModel]="dwPageSize"
        (ngModelChange)="onPageSizeChange($event)">
        <dw-option
          *ngFor="let option of dwPageSizeOptions"
          [dwLabel]="option + locale.items_per_page"
          [dwValue]="option">
        </dw-option>
        <dw-option
          *ngIf="dwPageSizeOptions.indexOf(dwPageSize)==-1"
          [dwLabel]="dwPageSize + locale.items_per_page"
          [dwValue]="dwPageSize">
        </dw-option>
      </dw-select>
      <div class="ant-pagination-options-quick-jumper"
        *ngIf="dwShowQuickJumper">
        {{ locale.jump_to }}
        <input #quickJumperInput (keydown.enter)="handleKeyDown($event,quickJumperInput,true)">
        {{ locale.page }}
      </div>
    </div>
  </ul>
</ng-container>